import React from 'react';
import { useTranslation } from 'react-i18next';
import { NotesEditor } from './notes-editor';
import { EmptyState } from '@/components/custom/empty-state';
import { NotesCard } from './notes-card';
import { Loader } from '@/components/custom/loader';
import { useNote } from '@/hooks/useNote';
import { NotesAside, NotesBody, NotesNav, NotesView } from './notes';
import { FormField } from '../form';

export function NotesPrivate(props) {
  const { hasNotes, handleNewNote, setSearchTerm, notes, setActiveNote, activeNote } = props;
  const { loading } = useNote();

  const { t } = useTranslation();

  if (!hasNotes)
    return loading ? (
      <Loader />
    ) : (
      <EmptyState
        type="register"
        title={t('emptyState.notesTitle')}
        text={t('emptyState.notesText')}
        cta={{ text: 'Fazer anotações', onClick: handleNewNote }}
        variant="plain"
      />
    );

  return (
    hasNotes && (
      <NotesBody>
        <NotesAside>
          <FormField
            aria-label={'Pesquisar'}
            placeholder={t('textsCommon.research')}
            type="search"
            name="search"
            onChange={e => setSearchTerm(e.target.value)}
          />

          <NotesNav>
            {notes?.map(note => (
              <NotesCard
                note={note}
                index={note.id}
                key={note.id}
                activeNote={activeNote}
                setActiveNote={setActiveNote}
                user={{ image: note.user.image.url, name: note?.user?.name, id: note?.user?.id }}
              />
            ))}
          </NotesNav>
        </NotesAside>

        <NotesView>
          <NotesEditor note={activeNote} />
        </NotesView>
      </NotesBody>
    )
  );
}
